import React, { useState, useEffect } from "react";
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from "axios";
import { baseurladdress } from "../baseurl"
import { useNavigate } from "react-router-dom";

import moment from "moment";
import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

const Swal = require('sweetalert2')
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1800,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export default function EditShift() {

    const navigate = useNavigate();
    const accesstoken = localStorage.getItem("token");
    const accessstaffid = localStorage.getItem("staffid");
    const [data, setTableData] = useState([]);
    const [shifttype, setshifttype] = useState([]);
    const [selectedbranch, setSelectedBranch] = useState(null);
    const [selectedshifttype, selectedshifttypes] = useState("");
    const [fromdate, setFromdate] = useState("");
    const [todate, setTodate] = useState("");
    const [reqto, setReqto] = useState([]);
    const [selectedreqto, setSelectedReqto] = useState("");
    const [shiftMode, setShiftMode] = useState('intra');
    const [branch, setBranch] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [shiftType, setShiftType] = useState([]);

    //     const handleSubmit = (event) => {
    //     event.preventDefault();
    //     const data = {
    //         type_id: selectedshifttype,
    //         date_from: fromdate,
    //         date_to: todate,
    //         requested_to: selectedreqto,
    //         staffid: accessstaffid,
    //         shift_mode: shiftMode,
    //         branch_id: shiftMode === 'inter' ? selectedbranch?.branch_id : null,
    //         branch_name: shiftMode === 'inter' ? selectedbranch?.branch_name : null,
    //     };
    //     fetch(
    //         baseurladdress + `addshiftreq`,
    //         {
    //             method: "POST",
    //             body: JSON.stringify(data),
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${accesstoken}`,
    //             },
    //         }
    //     )
    //         .then((res) => res.json())
    //         .then((result) => {
    //             if (result["status"] === "success") {
    //                 Toast.fire({
    //                     icon: 'success',
    //                     title: 'Staff added successfully'
    //                 })
    //                 window.location.href = "/shiftreq";
    //                 navigate("/shiftreq");
    //             }

    //         });
    // };
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!selectedshifttype) {
            Toast.fire({
                icon: "warning",
                title: "Please Select Shift Type"
            });
            return;
        }

        if (!fromdate) {
            Toast.fire({
                icon: "warning",
                title: "Please Select From Date"
            });
            return;
        }

        if (!todate) {
            Toast.fire({
                icon: "warning",
                title: "Please Select To Date"
            });
            return;
        }

        if (!selectedreqto) {
            Toast.fire({
                icon: "warning",
                title: "Please Select Request To"
            });
            return;
        }

        const payload = {
            type_id: selectedshifttype,
            date_from: fromdate,
            date_to: todate,
            requested_to: selectedreqto,
            staffid: accessstaffid,
            shift_mode: shiftMode,
            branch_id:
                shiftMode === "inter"
                    ? selectedbranch?.branch_id
                    : null,
            branch_name:
                shiftMode === "inter"
                    ? selectedbranch?.branch_name
                    : null,
        };

        console.log("Sending Payload:", payload);

        try {
            const response = await fetch(
                baseurladdress + "addshiftreq",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesstoken}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            console.log("API Response:", result);

            if (result.status === "success") {
                Toast.fire({
                    icon: "success",
                    title: "Shift Request Sent Successfully"
                });

                window.location.href = "/shiftreq";
            } else {
                Toast.fire({
                    icon: "error",
                    title: result.message || "Something went wrong"
                });
            }

        } catch (error) {
            console.error(error);

            Toast.fire({
                icon: "error",
                title: "Server Error"
            });
        }
    };
    useEffect(() => {
        axios.get(baseurladdress + "getallshifttype", {
            headers: {
                Authorization: `Bearer ${accesstoken}`
            }
        })
            .then((res) => {
                setShiftType(res.data.response);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);
    
    useEffect(() => {
        const getallbranchestype = () => {
            axios.get(baseurladdress + `getallbranchestype`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    setBranch(data);
                })
                .catch(error => {
                    alert(error);
                });
        };
        getallbranchestype();
    }, []);


    useEffect(() => {
        const getshiftrequestapprovers = async () => {
            try {
                const params = shiftMode === "inter" && selectedbranch?.branch_id
                    ? { branch_id: selectedbranch.branch_id }
                    : { staff_id: accessstaffid };
                const res = await axios.get(`${baseurladdress}getallshiftreqapprovers`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                    params
                });

                const data = res.data.response || [];
                const approverOptions = data.map(item => (
                    <option key={item.shap_staffid} value={item.shap_staffid}>
                        {item.shap_staffname}
                    </option>
                ));
                setReqto(approverOptions);

            } catch (error) {
                alert("Error fetching approvers: " + error);
            }
        };

        getshiftrequestapprovers();
    }, [shiftMode, selectedbranch]);


    useEffect(() => {
        const GetAllShiftreq = () => {
            const username = localStorage.getItem("username");
            const staffid = localStorage.getItem("staffid");
            axios
                .get(baseurladdress + `getallshiftreq`, {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                        Username: username,
                        StaffID: staffid
                    },
                })
                .then(res => {
                    const datas = res.data.response;
                    console.log("itemss" + datas);
                    const tdata = datas.map((item, index) => (
                        <tr>
                            <td>{index + 1}</td>
                            <td>{item.emp_name}</td>
                            <td>{item.type_name}</td>
                            <td>{moment(item.date_from).format("DD-MM-YYYY")}</td>
                            <td>{moment(item.date_to).format("DD-MM-YYYY")}</td>
                            <td>{item.shift_mode}</td>
                            <td >        <div>
                                {(() => {
                                    if (item.status == 1) {
                                        return (
                                            <div style={{ textAlign: "left" }}>
                                                <span class="badge bg-warning">
                                                    Pending
                                                </span>
                                            </div>
                                        );
                                    } else if (item.status == 5) {
                                        return (
                                            <div style={{ textAlign: "left" }}>
                                                <span class="badge bg-success">
                                                    Approved
                                                </span>
                                            </div>
                                        );
                                    } else if (item.status == 0) {
                                        return (
                                            <div style={{ textAlign: "left" }}>
                                                <span class="badge bg-danger">
                                                    Rejected
                                                </span>
                                            </div>
                                        );
                                    }
                                })()}
                            </div></td>


                        </tr>
                    ));

                    setTableData(tdata)
                })
                .catch(error => {
                    Toast.fire({
                        icon: 'error',
                        title: 'No shift request '
                    })
                })
        }

        GetAllShiftreq();
    }, []);

    $(function () {
        setTimeout(function () {
            $('#shiftreqlist').DataTable();
        }, 1000);
    });


    return (
        <>
            <Topnavbar />,
            <Sidennav />,
            <div className="content-wrap">
                <div className="row g-3">
                    <div className="col-12 col-lg-6">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Shift Request</h4>
                            </div>
                            <div className="card-body">
                                <div className="form-group">
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="shiftMode"
                                            id="intra"
                                            value="intra"
                                            checked={shiftMode === 'intra'}
                                            onChange={() => setShiftMode('intra')}
                                        />
                                        <label className="form-check-label" htmlFor="intra"><b>Intra</b></label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="shiftMode"
                                            id="inter"
                                            value="inter"
                                            checked={shiftMode === 'inter'}
                                            onChange={() => setShiftMode('inter')}
                                        />
                                        <label className="form-check-label" htmlFor="inter"><b>Inter</b></label>
                                    </div>
                                </div>

                                {shiftMode === 'inter' && (
                                    <div className="form-row">
                                        <div className="col-sm-12 mt-2">
                                            <h6>Select Branch</h6>
                                            <select
                                                value={selectedbranch?.branch_id || ""}
                                                onChange={(e) => {
                                                    const selected = branch.find(item => item.branch_id === parseInt(e.target.value));
                                                    setSelectedBranch(selected);
                                                }}
                                                className="form-control"
                                            >
                                                <option value="">Select Branch</option>
                                                {branch.map((item) => (
                                                    <option key={item.branch_id} value={item.branch_id}>
                                                        {item.branch_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="form-row">
                                        <div className="col-sm-6 mt-2">
                                            <h6>Type</h6>
                                           
                                            <select
                                                className="form-control"
                                                value={selectedshifttype}
                                                onChange={(e) => selectedshifttypes(e.target.value)}
                                            >
                                                <option value="">Select Shift Type</option>

                                                {shiftType.map((item) => (
                                                    <option
                                                        key={item.type_id}
                                                        value={item.type_id}
                                                    >
                                                        {item.type_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
            
                                        <div className="col-sm-6 mt-2">
                                            <h6>From Date</h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromdate}
                                                min={today}
                                                onChange={(e) => setFromdate(e.target.value)}
                                            />

                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6 mt-3">
                                            <h6>To Date</h6>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={todate}
                                                min={today}
                                                onChange={(e) => setTodate(e.target.value)}
                                            />

                                        </div>
                                        <div className="col-sm-6 mt-3">
                                            <h6>Request To</h6>
                                            <select
                                                className="form-control select"
                                                name="request_to"
                                                onChange={(e) => setSelectedReqto(e.target.value)}
                                                value={selectedreqto}
                                            >
                                                <option value="" disabled>Requested to</option>
                                                {reqto}
                                            </select>
                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="col-12 mt-4">
                                            <button type="submit" className="btn btn-primary">
                                                Send Request
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>


                    <div className="col-12 col-lg-6">
                        <div className="card h-100">
                            <div className="card-header">
                                <h4 className="card-title">Requests Overview</h4>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered" id="shiftreqlist">
                                        <thead>
                                            <tr>
                                                <th>Sl.No</th>
                                                <th>Staff name</th>
                                                <th>Shift</th>
                                                <th>From Date</th>
                                                <th>To Date</th>
                                                <th>Shift Mode</th>
                                                <th style={{ textAlign: "left" }}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
};